import React from 'react';

import { useAppDispatcher } from 'hooks/useAppDispatcher';
import { useAppState } from 'hooks/useAppState';
import { useAsyncProcess } from 'hooks/useAsyncProcess';
import { PartnerClientsTableSortableField } from 'types/partnerClientsTable';

type Params = {
  fieldToSortTableBy: PartnerClientsTableSortableField;
};

export const usePartnerClientsPageCancelledData = (params: Params) => {
  const dispatch = useAppDispatcher();

  const startProcess = useAsyncProcess();

  const {
    partnerDashboard: {
      cancelledClients: partnerCancelledClientsTableItems,
      cancelledClientsInvalidated,
    },
  } = useAppState();

  const partnerCancelledClientsCount = partnerCancelledClientsTableItems.length;

  const partnerCancelledLicensesCount = React.useMemo(() => {
    return partnerCancelledClientsTableItems.reduce((acc, item) => {
      return acc + item.licensesCount;
    }, 0);
  }, [partnerCancelledClientsTableItems]);

  React.useLayoutEffect(() => {
    if (cancelledClientsInvalidated) {
      startProcess((services) =>
        services.getPartnerCancelledClientsTableItems().then((items) => {
          dispatch({
            name: 'PartnerClientsPage__CancelledClientsTableItemsRecieved',
            items,
          });
        })
      );
    }
  }, [cancelledClientsInvalidated, dispatch, startProcess]);

  return {
    partnerCancelledClientsCount,
    partnerCancelledLicensesCount,
    partnerCancelledClientsTableItems,
  };
};
